var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClassOpts({ skeleton: true }),attrs:{"disabled":"","type":"button"}})}
var staticRenderFns = []

export { render, staticRenderFns }